"use client";

import Input from "@client/components/formik/input";
import { setUserInteractionDataAttribute } from "@shared/constants";
import kebabToCamelCase from "@shared/functions/kebabToCamelCase";

import Fieldset from "@ui/js/components/form/fieldset";
import { Tile } from "@ui/js/components/tiles/tile";
import { useFormikContext } from "formik";

const INPUT_ID_AND_LABEL_HTMLFOR = "loan-timing";
const FIELD_NAME_SELECTOR = kebabToCamelCase(INPUT_ID_AND_LABEL_HTMLFOR);
export default function LoanTiming() {
	const { setFieldValue } = useFormikContext();
	const handleClick = (e: any) => {
		setFieldValue(FIELD_NAME_SELECTOR, e.currentTarget.value);
	};
	return (
		<Fieldset legend="How quickly do you need a loan?">
			<Input
				type="hidden"
				name={FIELD_NAME_SELECTOR}
				id={INPUT_ID_AND_LABEL_HTMLFOR}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__within_48_hours`,
				)}
				label="Within 48 hours"
				value="within_48_hours"
				onClick={handleClick}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__within_2_weeks`,
				)}
				label="Within 2 weeks"
				value="within_2_weeks"
				onClick={handleClick}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__within_1_month`,
				)}
				label="Within 1 month"
				value="within_1_month"
				onClick={handleClick}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__unsure`,
				)}
				label="Unsure, just browsing options"
				value="unsure"
				onClick={handleClick}
			/>
		</Fieldset>
	);
}
